import { render, staticRenderFns } from "./PartyBuilding.vue?vue&type=template&id=4d8e7f9b&scoped=true"
import script from "./PartyBuilding.vue?vue&type=script&lang=js"
export * from "./PartyBuilding.vue?vue&type=script&lang=js"
import style0 from "./PartyBuilding.vue?vue&type=style&index=0&id=4d8e7f9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8e7f9b",
  null
  
)

export default component.exports